export default "__VITE_ASSET__kzgetA6n__"